import Layout from "layout/Layout";
import UtmLinksManager from "./components/UtmLinksManager";

export default function UtmLinksPage() {
  return (
    <Layout>
      <h1 className="text-2xl font-bold text-gray-900 mb-4">UTM Links</h1>
      <UtmLinksManager />
    </Layout>
  );
}
